"use client";

import styles from "@/styles/home/recommend-list.module.scss";
import { useState } from "react";
import Image from "next/image";
import ProductItem from "@/components/global/ProductItem";
import { List } from "react-vant";
import homeApi from "@/service/modules/homeApi";
import { ProductType } from '@/types/product';

export default function RecommendList() {
  const [recommendList, setRecommendList] = useState<ProductType[]>([]);
  const [finished, setFinished] = useState<boolean>(false)

  const getRecommendData = async () => {
    try {
      let startIndex = -1
      if (recommendList && recommendList.length) {
        startIndex = recommendList[recommendList.length - 1].pageOffset || -1
      }

      const paramsObj = {
        start: startIndex,
        perPage: 10,
      };

      const { data } = await homeApi.getHomeRecommended(paramsObj);

      if (data.pageList.items) {
        return data.pageList.items;
      } else {
        return false;
      }
    } catch {
      return false;
    }
  };

  const onLoad = async () => {
    const data = await getRecommendData();
    if (data) {
      setRecommendList((v) => [...v, ...data]);
    } else {
      setFinished(true)
    }
  };

  return (
    <div className={styles["comp-recommend-list"]}>
      <List
        className={styles["recommend-list"]}
        finished={finished}
        onLoad={onLoad}
        loadingText={
          <Image
            src={`${process.env.IMAGE_DOMAIN}/home/loading.svg`}
            alt="Loading"
            width={36}
            height={36}
          />
        }
        finishedText={'Finished !'}
        errorText={'Load Error !'}
      >
        {recommendList.map((product: ProductType) => (
          <div className={styles["recommend-item"]} key={product.productID}>
            <ProductItem product={product} />
          </div>
        ))}
      </List>
    </div>
  );
}
